<s1-input-multiselect class="mb-2" [control]="control" [label]="label" [options]="options" (onSelectClear)="cleared()" (onSelectChange)="changed($event)"></s1-input-multiselect>
